import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { ClientInterest } from 'reducers/interests/interests.types'

export const addHighlightedItem = (
  interestList: NonNullable<
    GQLForeignRootQuery['user']
  >['interests']['interests']['nodes'],
  currentUserInterestList: NonNullable<
    GQLForeignRootQuery['my']
  >['interests']['interests']['nodes']
): ClientInterest[] => {
  if (currentUserInterestList.length > 0) {
    const currentUserInterestListOnlyText = currentUserInterestList.reduce(
      (acc, { text }) => {
        return [...acc, text]
      },
      [] as string[]
    )

    return interestList.map(({ interestId, text }) => ({
      id: interestId,
      text,
      itemHighlighted: currentUserInterestListOnlyText.includes(text),
    }))
  } else {
    return interestList.map(({ interestId, text }) => ({
      id: interestId,
      text,
      itemHighlighted: false,
    }))
  }
}
